import { VTRS, VTRSConfig } from "@/classes";
import { Plugin } from "vue-demi";

const plugin: (config: VTRSConfig) => Plugin = function Auth(
  config: VTRSConfig
) {
  const _vtrs = new VTRS(config);
  const Plugin = {
    install(Vue: any) {
      Vue.$vtrs = _vtrs;
    }
  };

  Plugin.install = Vue => {
    Vue.$vtrs = _vtrs;
    Object.defineProperties(Vue.prototype, {
      $vtrs: {
        get() {
          return _vtrs;
        }
      }
    });
  };

  return Plugin;
};

export default plugin;
